// opervex-frontend/src/Opervex/Financial/Categories.js

class Categories {
  #_api;
  constructor(api) {
    this.#_api = api;
  }

  async findAll() {
    return this.#_api.get("/Financial/Categories");
  }

  async findId(id) {
    return this.#_api.get(`/Financial/Categories/${id}`);
  }

  async create(data) {
    return this.#_api.post("/Financial/Categories", data);
  }

  async update(id, data) {
    return this.#_api.put(`/Financial/Categories/${id}`, data);
  }

  async schema() {
    return [
      { key: "id", label: "Código", type: "number", visible: true },
      { key: "description", label: "Descrição", type: "string", visible: true },
      { key: "disabled", label: "Inativo", type: "boolean", visible: true },
    ];
  }
}
export default Categories;
